import React from "react";
import { Box } from "@mui/material";
import { useGoogleScript } from "../../Contexts/GoogleScriptContext";
import MapSkeleton from "../ShimmerSkeleton/MapSkeleton";
import LocationSearchSkeleton from "../ShimmerSkeleton/LocationSearchSkeleton";

const GoogleScriptGate = ({ children, type = "map" }) => {
  const { isLoaded } = useGoogleScript();

  if (!isLoaded) {
    return (
      <Box sx={{ width: "100%", height: type === "map" ? "100%" : "auto" }}>
        {type === "map" ? <MapSkeleton /> : <LocationSearchSkeleton />}
      </Box>
    );
  }

  return children;
};

export default GoogleScriptGate;
